/**
 * @file    chartTypeLabel.ts
 * @scope   SHARED
 * @summary Fallback display names for chart types, used when Guardrails does not send a `label`.
 * @consumes Nothing.
 * @produces chartTypeLabel map (chartType -> human readable label).
 * @sideEffects None.
 */

/**
 * WHY: Guardrails returns technical chart identifiers (`HorizontalSingleStackedBarChart`).
 * The drawer dropdown must show business wording, so unlabelled entries fall back to this map.
 */
export const chartTypeLabel = {
  VerticalBarChart: 'Vertical Bar',
  PieChart: 'Doughnut',
  HorizontalSingleStackedBarChart: 'Horizontal Single Stacked',
  DynamicTable: 'Data Grid',
  DataGridMetrics: 'Data Grid Metrics',
  DataGrid: 'Data Grid',
  MetricSummary: 'Summary Metric Stats',
  HorizontalBarChart: 'Horizontal Bar',
  StackedBarChart: 'Grouped Bar/Line',
  GeoMap: 'Geo Map',
  IndividualMetric: 'Individual Metric',
  TextBlock: 'Text Block',
  BulletChart: 'Bullet Chart',
  CrossProgramRollup: 'Cross Program Rollup',
};

/** Keys accepted by {@link chartTypeLabel}. */
export type ChartTypeLabelKey = keyof typeof chartTypeLabel;
